import {Mesh, MeshStandardMaterial} from 'three'
import {TextGeometry} from 'three/examples/jsm/geometries/TextGeometry.js'
import {Font} from 'three/examples/jsm/loaders/FontLoader.js'

export interface CreateTextMeshOptions {
  text: string
  font: Font
  color?: number
  size?: number
  depth?: number
  curveSegments?: number
  bevelEnabled?: boolean
  bevelThickness?: number
  bevelSize?: number
  bevelOffset?: number
  bevelSegments?: number
  metalness?: number
  roughness?: number
}

/**
 * Создание текстового mesh из текста, шрифта и цвета
 */
export function createTextMesh(options: CreateTextMeshOptions): Mesh {
  const {
    text,
    font,
    color = 0xffffff,
    size = 1,
    depth = 0.2,
    curveSegments = 12,
    bevelEnabled = true,
    bevelThickness = 0.03,
    bevelSize = 0.02,
    bevelOffset = 0,
    bevelSegments = 5,
    metalness = 0.3,
    roughness = 0.4,
  } = options

  const geometry = new TextGeometry(text, {
    font: font,
    size: size,
    depth: depth,
    curveSegments: curveSegments,
    bevelEnabled: bevelEnabled,
    bevelThickness: bevelThickness,
    bevelSize: bevelSize,
    bevelOffset: bevelOffset,
    bevelSegments: bevelSegments,
  })

  geometry.computeBoundingBox()
  if (geometry.boundingBox) {
    const centerOffsetX =
      -0.5 * (geometry.boundingBox.max.x - geometry.boundingBox.min.x)
    const centerOffsetY =
      -0.5 * (geometry.boundingBox.max.y - geometry.boundingBox.min.y)
    geometry.translate(centerOffsetX, centerOffsetY, 0)
  }

  const material = new MeshStandardMaterial({
    color: color,
    metalness: metalness,
    roughness: roughness,
  })

  return new Mesh(geometry, material)
}
